// Text for the "🔥 N deals" header above the deal grid.
//
// It counts what the visitor can actually scroll through (pagination.totalDeals),
// so it can never promise more than "You've seen all available deals!" delivers.
// pagination.approxTotal (all eligible deals site-wide) is deliberately NOT used:
// the curated feed only scores a fixed candidate pool, so it is always larger.
// Counts in the thousands are rounded down ("1,000+").
export const formatDealCount = (pagination = {}) => {
  const count = (pagination && pagination.totalDeals) || 0;
  const label = count >= 1000
    ? `${(Math.floor(count / 1000) * 1000).toLocaleString()}+`
    : count.toLocaleString();
  return `${label} ${count === 1 ? 'deal' : 'deals'}`;
};

export default formatDealCount;
